export default "__VITE_ASSET__BfUvEjpa__"